import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import DollarAmount from '../DollarAmount';
export default function Spend(_ref) {
  var amount = _ref.amount,
    unit = _ref.unit,
    isCostBased = _ref.isCostBased;
  return isCostBased ? /*#__PURE__*/React.createElement(DollarAmount, {
    convertCents: true,
    value: amount || 0
  }) : /*#__PURE__*/React.createElement("span", null, amount, " ", pluralize(unit || '', amount));
}
;
Spend.propTypes = {
  amount: PropTypes.number.isRequired,
  unit: PropTypes.string,
  isCostBased: PropTypes.bool.isRequired
};
//# sourceMappingURL=Spend.js.map